var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-divider',{staticClass:"mb-1 mt-6 neutral700"}),_c('div',{staticClass:"text-xxs italic neutral500--text"},[_vm._v("This certificate was generated digitally. No signature needed for this document")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }